module.exports = __webpack_public_path__ + "media/icons/finansowanie-menu-057936e6.png";